import * as yup from 'yup';

export const fitnessGoalsFormSchema = yup.object().shape({
  title: yup.string().required('Required'),
  sub_title: yup.string().required('Required'),
  description: yup.string().required('Required')
});
